import * as crypto from 'crypto-js';
import { AppConfig } from '../config/AppConfig';

export class CodificadorJWT {

    private HEADER = {
		alg: AppConfig.JWT_ALGORITMO,
		typ: AppConfig.JWT_TIPO
	};
	private ISS = AppConfig.JWT_ISS
	private KEY = null;
	private argumentos;
	private payload: any;
	
    // valiodar JWT
	algorithm = 'sha256';
	hash;
	hmac;
	CARACTER_ESPECIAL = '0x';
	inicio;

	constructor() {}

	generarJSON(argumentos, valueAes:string) {
		if (this.KEY === null) {
			this.KEY = valueAes;
		}

		this.argumentos = argumentos;

		this.payload = {     
			iss: this.ISS,       
            args: this.argumentos
        };

		const unsignedToken = btoa(JSON.stringify(this.HEADER)) + '.' + this.b64EncodeUnicode(JSON.stringify(this.payload));

		const signature = crypto.HmacSHA256(unsignedToken, this.KEY);

		let hashInBase64 = crypto.enc.Base64.stringify(signature);
		hashInBase64 = hashInBase64.replace(/=+$/, '');
		hashInBase64 = hashInBase64.replace(/\+/g, '-');
		hashInBase64 = hashInBase64.replace(/\//g, '_');

		return btoa(JSON.stringify(this.HEADER)) + '.' + this.b64EncodeUnicode(JSON.stringify(this.payload)) + '.' + hashInBase64;
	}

    b64EncodeUnicode(str) {
		// first we use encodeURIComponent to get percent-encoded UTF-8,
		// then we convert the percent encodings into raw bytes which
		// can be fed into btoa.
		return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
			(match, p1) => {
				this.inicio = this.CARACTER_ESPECIAL + p1;
				return String.fromCharCode(this.inicio);
			}));
	}

	encriptarKey(header: string, payload: string, valueAes:string) {
		if (this.KEY === null) {
			this.KEY = valueAes;
		}

		const unsignedToken = header + '.' + payload;
		const signature = crypto.HmacSHA256(unsignedToken, this.KEY);

		let hashInBase64 = crypto.enc.Base64.stringify(signature);
		hashInBase64 = hashInBase64.replace(/=+$/, '');
		hashInBase64 = hashInBase64.replace(/\+/g, '-');
		hashInBase64 = hashInBase64.replace(/\//g, '_');

		return hashInBase64;
	}
}